import React, { useState, useEffect, useRef } from "react";
import NavigationButtons from "../../../Common/CommonButtons/NavigationButtons";
import ActionButtonGroup from "../../../Common/CommonButtons/ActionButtonGroup";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AccountMasterHelp from "../../../Helper/AccountMasterHelp";
import UserAuditInfo from "../../../Common/UserAuditInfo/UserAuditInfo";
import SearchBar from "../../../Common/UtilityCommon/SearchBar";
import { formatReadableAmount } from "../../../Common/FormatFunctions/FormatAmount";
import {
  TextField, Grid, Box, Card, CardContent, debounce, Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox
} from "@mui/material";
import RTGSReport from "./RTGSReport";
import CheckRTGSReport from "./RTGSCheckPrint";
import Swal from "sweetalert2";
import PattiRTGSReport from "./RTGSPattiReport";
import { OutwordPostDateRecordLock } from "../../../Common/PostDateLock/PostDateRangeCheck";
import { validateDocumentDate } from "../../../Common/ValidateDateRange/ValidateDateRange";


const API_URL = process.env.REACT_APP_API;

//Labels Global variables
var PurchName = "";
var PurchCode = "";
var BankName = "";
var BankCode = "";
var BankAccoid = "";
var GStrateName = "";
var selectedfilter = "";

const headerCellStyle = {
  fontWeight: "bold",
  backgroundColor: "#3f51b5",
  color: "white",
  padding: "6px",
  textAlign: "center",
  "&:hover": {
    backgroundColor: "#303f9f",
    cursor: "pointer",
  },
};

const RTGSForm = () => {
  const location = useLocation();
  selectedfilter = location.state?.selectedfilter;
  const inputRef = useRef(null);
  const searchParams = new URLSearchParams(location.search);
  const navigatedRecord = searchParams.get('navigatedRecord');

  const permissions = location.state?.permissionsData;

  const Year_Code = sessionStorage.getItem("Year_Code");
  const Company_Code = sessionStorage.getItem("Company_Code");

  const [updateButtonClicked, setUpdateButtonClicked] = useState(false);
  const [saveButtonClicked, setSaveButtonClicked] = useState(false);
  const [addOneButtonEnabled, setAddOneButtonEnabled] = useState(false);
  const [saveButtonEnabled, setSaveButtonEnabled] = useState(true);
  const [cancelButtonEnabled, setCancelButtonEnabled] = useState(true);
  const [editButtonEnabled, setEditButtonEnabled] = useState(false);
  const [deleteButtonEnabled, setDeleteButtonEnabled] = useState(false);
  const [backButtonEnabled, setBackButtonEnabled] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const [highlightedButton, setHighlightedButton] = useState(null);
  const [cancelButtonClicked, setCancelButtonClicked] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [SystemType, setSystemType] = useState(selectedfilter);
  const [purchaseAccount, setPurchaseAccount] = useState("");
  const [bankaccount, setbankAccount] = useState("");
  const [bankaccoid, setbankaccoid] = useState("");
  const [bankname, setbankname] = useState("");
  const [gstRateCode, setgstRateCode] = useState("");
  const [isHandleChange, setIsHandleChange] = useState(false);
  const companyCode = sessionStorage.getItem("Company_Code");
  const username = sessionStorage.getItem("username");
  const [formErrors, setFormErrors] = useState({});

  const [selectedPattiIds, setSelectedPattiIds] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const [users, setUsers] = useState([]);


  const selectedRecord = location.state?.selectedRecord;


  const initialFormData = {
    Slip_No: "",
    Doc_Date: new Date().toISOString().split("T")[0],
    Our_Bank: "",
    Bank_Name: "",
    Ac_code: 0,
    Party_name: "",
    Party_Bank: "",
    Party_Branch: "",
    Ifsc: 0,
    Party_Ac_No: 0,
    Ac: 0,
    Our_Branch: "",
    Our_AC_No: 0,
    Amount: 0.0,
    Charges: 0.0,
    Total: 0.0,
    cheque_No: "",
    Challan_No: "",
    UTR_No: "",
    Company_Code: companyCode,
    Year_Code: Year_Code,
    Created_By: "",
    Modified_By: "",
    PaymentCategory: "",
    Bank_Code: "",
    bc: "",
    SubTotal: 0.00,
    Sauda_Hamali: 0.00,
    Vatav: 0.00,
    Other: 0.00,
    Net_Payable: 0.00,
  };

  const [formData, setFormData] = useState(initialFormData);


  const validateNumericInput = (e) => {
    e.target.value = e.target.value.replace(/[^0-9.-]/g, '');
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "PaymentCategory") {
      if (value === "P") {
        try {
          const response = await fetch(
            `${API_URL}/getall-PattiDatabyPaymentCategory?Company_Code=${companyCode}`
          );
          const data = await response.json();

          if (data.all_data) {
            setUsers(data.all_data);
          }
        } catch (error) {
          console.error("Error fetching Patti data:", error);
        }
      } else {
        setUsers([]);
      }
    }
  };

  const fetchLastRecordSystemCode = () => {

    fetch(
      `${API_URL}/get-RTGS-lastRecord?Company_Code=${companyCode}`,
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch last record");
        }
        return response.json();
      })
      .then((data) => {
        const last = data?.last_rtgs_data;

        // If we have a valid System_Code, increment it, otherwise start from 1
        const nextCode =
          last && last.Slip_No != null && !isNaN(Number(last.Slip_No))
            ? Number(last.Slip_No) + 1
            : 1;

        setFormData((prevState) => ({
          ...prevState,
          Slip_No: nextCode,
        }));
      })
      .catch((error) => {
        console.error("Error fetching last record:", error);
        // On error you can also choose to default to 1 if you want:
        setFormData((prevState) => ({
          ...prevState,
          Slip_No: 1,
        }));
      });
  };

  const handleAddOne = () => {

    setAddOneButtonEnabled(false);
    setSaveButtonEnabled(true);
    setCancelButtonEnabled(true);
    setEditButtonEnabled(false);
    setDeleteButtonEnabled(false);
    setIsEditing(true);
    fetchLastRecordSystemCode();
    setUsers([]);
    setSelectedPattiIds([]);
    setFormData(initialFormData);
    PurchName = "";
    PurchCode = "";
    BankName = "";
    BankCode = "";
    BankAccoid = "";
    setTimeout(() => {
      inputRef.current?.focus();
    }, 0);
  };

  useEffect(() => {
    if (selectedRecord) {
      handlerecordDoubleClicked();
    } else {
      handleAddOne();
    }
  }, [selectedRecord]);

  // useEffect(() => {
  //   if (location.state) {
  //     setFormData(prev => ({
  //       ...prev,
  //       ...location.state
  //     }));
  //   }
  // }, [location.state]);

  useEffect(() => {

    if (!location.state) return;

    // handleAddOne(); // reset first

    const data = location.state;

    // Update global variables
    PurchCode = data.Ac_code || 0;
    PurchName = data.Party_name || "";

    BankCode = data.Bank_Code || "";
    BankName = data.Bank_Name || ""

    setFormData(prev => ({
      ...prev,
      ...data
    }));
  }, [location.state]);


  const handleSaveOrUpdate = async () => {


    const Post_Date = sessionStorage.getItem("Post_Date");
    const Outword_Date = sessionStorage.getItem("Outword_Date")
    if (await OutwordPostDateRecordLock(formData.Doc_Date, Post_Date, Outword_Date)) {
      return;
    }

    const accountingYearData = sessionStorage.getItem("Accounting_Year");
    const formattedEntryDate = formData.Doc_Date;
    const isValid = validateDocumentDate(
      formattedEntryDate,
      accountingYearData
    );

    if (!isValid) {
      return;
    }
    let updatedFormData = {
      ...formData,
      selectedPattiIds: selectedPattiIds,
    };
    delete updatedFormData.permissionsData;

    if (isEditMode) {

      updatedFormData = {
        ...updatedFormData,
        Modified_By: username,
      };

      axios
        .put(
          `${API_URL}/update-RTGS?Slip_No=${formData.Slip_No}&Company_Code=${companyCode}&Year_Code=${Year_Code}`,
          updatedFormData
        )
        .then((response) => {
          Swal.fire({
            title: "Success!",
            text: "Record updated successfully!",
            icon: "success",
            confirmButtonText: "OK",
          });

          // setSelectedPattiIds([]);   // optional reset

          setIsEditMode(false);
          setAddOneButtonEnabled(true);
          setEditButtonEnabled(true);
          setDeleteButtonEnabled(true);
          setBackButtonEnabled(true);
          setSaveButtonEnabled(false);
          setCancelButtonEnabled(false);
          setUpdateButtonClicked(true);
          setIsEditing(false);
        })
        .catch((error) => {
          handleCancel();
          console.error("Error updating data:", error);
        });

    } else {

      updatedFormData = {
        ...updatedFormData,
        Created_By: username,
      };

      axios
        .post(
          `${API_URL}/create-Record-RTGS?Company_Code=${companyCode}&Year_Code=${Year_Code}`,
          updatedFormData
        )
        .then((response) => {
          Swal.fire({
            title: "Success!",
            text: "Record Created successfully!",
            icon: "success",
            confirmButtonText: "OK",
          });

          // setSelectedPattiIds([]);   // optional reset

          setIsEditMode(false);
          setAddOneButtonEnabled(true);
          setEditButtonEnabled(true);
          setDeleteButtonEnabled(true);
          setBackButtonEnabled(true);
          setSaveButtonEnabled(false);
          setCancelButtonEnabled(false);
          setUpdateButtonClicked(true);
          setIsEditing(false);
          handleCancel();
        })
        .catch((error) => {
          console.error("Error saving data:", error);
        });
    }
  };




  const handleEdit = () => {
    setIsEditMode(true);
    setAddOneButtonEnabled(false);
    setSaveButtonEnabled(true);
    setCancelButtonEnabled(true);
    setEditButtonEnabled(false);
    setDeleteButtonEnabled(false);
    setBackButtonEnabled(true);
    setIsEditing(true);
  };



  const handleCancel = () => {

    axios
      .get(`${API_URL}/get-RTGS-lastRecord?Company_Code=${companyCode}`)
      .then((response) => {

        const data = response.data;

        if (data && data.last_rtgs_data) {
          PurchName = data.labels.Ac_Name_E;
          PurchCode = data.last_rtgs_data.Ac_code;
          BankName = data.labels.BankName;
          BankCode = data.last_rtgs_data.Bank_Code;
          BankAccoid = data.last_rtgs_data.bc;
          //  Set main form data
          setFormData(data.last_rtgs_data);

          if (data.patti_details && data.patti_details.length > 0) {

            setUsers(data.patti_details);

            const normalizedIds = data.patti_details.map(
              (item) => item.Id
            );

            setSelectedPattiIds(normalizedIds);

          } else {
            setUsers([]);
            setSelectedPattiIds([]);
          }

        } else {
          console.error("No data found");
        }

      })
      .catch((error) => {
        console.error("Error fetching latest data:", error);
      });

    setIsEditing(false);
    setIsEditMode(false);
    setAddOneButtonEnabled(true);
    setEditButtonEnabled(true);
    setDeleteButtonEnabled(true);
    setBackButtonEnabled(true);
    setSaveButtonEnabled(false);
    setCancelButtonEnabled(false);
  };


  const handleDelete = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: `You want to delete SLIP NO: ${formData.Slip_No}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      cancelButtonText: "Cancel",
      confirmButtonText: "Yes, Delete",
      reverseButtons: true,
      focusCancel: true,
    });

    if (result.isConfirmed) {
      // Update UI state
      setIsEditMode(false);
      setAddOneButtonEnabled(true);
      setEditButtonEnabled(true);
      setDeleteButtonEnabled(true);
      setBackButtonEnabled(true);
      setSaveButtonEnabled(false);
      setCancelButtonEnabled(false);

      try {
        const deleteApiUrl = `${API_URL}/delete-RTGS?Slip_No=${formData.Slip_No}&Company_Code=${companyCode}&Year_Code=${Year_Code}`;
        const response = await axios.delete(deleteApiUrl);

        Swal.fire({
          title: "Deleted!",
          text: "Record deleted successfully!",
          icon: "success",
          confirmButtonText: "OK",
        });

        handleCancel();
      } catch (error) {
        toast.error("Something went wrong!");
        console.error("Error during API call:", error);
      }
    } else {
      Swal.fire({
        title: "Cancelled",
        text: "Your record is safe 🙂",
        icon: "info",
      });
    }
  };

  const handleBack = () => {
    navigate("/RTGS-utility");
  };

  const fetchRTGSData = async (url, dataKey) => {

    try {
      const response = await fetch(url);

      if (response.ok) {
        const data = await response.json();
        const systemData = data[dataKey];

        PurchName = data.labels.Ac_Name_E || "";
        PurchCode = systemData.Ac_code || "";
        BankName = data.labels?.BankName || "";
        BankCode = systemData.Bank_Code || "";
        BankAccoid = systemData.bc || "";

        setFormData((prev) => ({
          ...prev,
          ...systemData,
        }));

        //  IMPORTANT: Set Patti details into table
        if (data.patti_details && data.patti_details.length > 0) {

          setUsers(data.patti_details);

          // also mark checkboxes
          const ids = data.patti_details.map(item => item.Id);
          setSelectedPattiIds(ids);
        } else {
          setUsers([]);
          setSelectedPattiIds([]);
        }

      } else {
        console.error("Failed to fetch data");
      }
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };

  const handleChangeCheckbox = (e, pattiid) => {

    let updatedIds;

    const numericId = Number(pattiid);

    if (e.target.checked) {
      updatedIds = [...selectedPattiIds, numericId];
    } else {
      updatedIds = selectedPattiIds.filter(id => id !== numericId);
    }


    setSelectedPattiIds(updatedIds);

    const subtotal = users
      .filter(row => updatedIds.includes(row.Id))
      .reduce((total, row) => {
        return total + Number(
          (row.Patti_Amount || 0).toString().replace(/,/g, "")
        );
      }, 0);



    setFormData(prev => {
      return calculateDependentValues("SubTotal", subtotal, {
        ...prev,
        SubTotal: subtotal || 0.00,
      });
    });
  };

  const handleFirstButtonClick = async () => {
    const url = `${API_URL}/get-first-RTGS?Company_Code=${companyCode}`;
    await fetchRTGSData(url, "first_rtgs_data");
  };

  const handlePreviousButtonClick = async () => {
    const url = `${API_URL}/get-previous-RTGS?Company_Code=${companyCode}&Slip_No=${formData.Slip_No}`;
    await fetchRTGSData(url, "previous_rtgs_data");
  };

  const handleNextButtonClick = async () => {
    const url = `${API_URL}/get-next-RTGS?Company_Code=${companyCode}&Slip_No=${formData.Slip_No}`;
    await fetchRTGSData(url, "next_rtgs_data");
  };

  const handleLastButtonClick = async () => {

    const url = `${API_URL}/get-RTGS-lastRecord?Company_Code=${companyCode}`;
    await fetchRTGSData(url, "last_rtgs_data");
  };

  const handlerecordDoubleClicked = async () => {
    const url = `${API_URL}/get-RTGSSelectedRecord?Company_Code=${companyCode}&Slip_No=${selectedRecord.Slip_No}`;
    await fetchRTGSData(url, "selected_Record_data");
    setIsEditing(false);
    setIsEditMode(false);
    setAddOneButtonEnabled(true);
    setEditButtonEnabled(true);
    setDeleteButtonEnabled(true);
    setBackButtonEnabled(true);
    setSaveButtonEnabled(false);
    setCancelButtonEnabled(false);
    setUpdateButtonClicked(true);
  };




  const handleKeyDown = async (event) => {
    if (event.key === "Tab") {
      const changeNoValue = event.target.value;
      const url = `${API_URL}/get-RTGSSelectedRecord?Company_Code=${companyCode}&Slip_No=${changeNoValue}`;
      await fetchRTGSData(url, "selected_Record_data");
      setIsEditing(false);
    }
  };



  // const handlePurchaseAccount = async (code, accoid) => {
  //   
  //   setPurchaseAccount(code);

  //   // keep existing values
  //   setFormData(prev => ({
  //     ...prev,
  //     Ac_code: code,
  //     Ac: accoid,
  //   }));

  //   try {
  //     const response = await fetch(
  //       `${API_URL}/TransferDataTo-RTGS?Company_Code=${Company_Code}&Ac_code=${code}`
  //     );

  //     const result = await response.json();

  //     if (response.ok && result.all_data?.length > 0) {
  //       const data = result.all_data[0]; // first record
  //       setUsers(result.all_data);
  //       setFormData(prev => ({
  //         ...prev,
  //         Party_name: data.Ac_Name_E?.trim() || "",
  //         Party_Bank: data.Bank_Name?.trim() || "",
  //         Party_Branch: data.Branch?.trim() || "",
  //         Party_Ac_No: data.Bank_Ac_No?.trim() || "",
  //         Ifsc: data.IFSC || "",
  //       }));
  //     } else {
  //       // 🔹 If no data found, clear fields
  //       setFormData(prev => ({
  //         ...prev,
  //         Party_name: "",
  //         Party_Bank: "",
  //         Party_Branch: "",
  //         Party_Ac_No: "",
  //         Ifsc: "",
  //       }));
  //     }
  //   } catch (error) {
  //     console.error("RTGS fetch error:", error);
  //   }
  // };


  const handlePurchaseAccount = async (code, accoid) => {
    ;
    setPurchaseAccount(code);

    setFormData((prev) => ({
      ...prev,
      Ac_code: code,
      Ac: accoid,
    }));

    try {
      // Existing API
      const response = await fetch(
        `${API_URL}/TransferDataTo-RTGS?Company_Code=${Company_Code}&Ac_code=${code}`
      );

      const result = await response.json();

      // New API
      const response2 = await fetch(
        `${API_URL}/TransferDataTo-RTGS-FromRecepitPyament?Company_Code=${Company_Code}&Year_Code=${Year_Code}&Ac_code=${code}`
      );

      const result2 = await response2.json();

      // First API Data
      if (response.ok && result.all_data?.length > 0) {
        const data = result.all_data[0];

        setUsers(result.all_data);

        setFormData((prev) => ({
          ...prev,
          Party_name: data.Ac_Name_E?.trim() || "",
          Party_Bank: data.Bank_Name?.trim() || "",
          Party_Branch: data.Branch?.trim() || "",
          Party_Ac_No: data.Bank_Ac_No?.trim() || "",
          Ifsc: data.IFSC || "",
        }));
      }

      // Second API Data (override if found)
      if (response2.ok && result2.all_data?.length > 0) {
        const data2 = result2.all_data[0];

        setFormData((prev) => ({
          ...prev,
          Party_name: data2.Ac_Name_E?.trim() || prev.Party_name,
          Party_Bank: data2.Bank_Name?.trim() || prev.Party_Bank,
          Party_Branch: data2.Branch?.trim() || prev.Party_Branch,
          Party_Ac_No: data2.Bank_Ac_No?.trim() || prev.Party_Ac_No,
          Ifsc: data2.IFSC || prev.Ifsc,
        }));
      }

      // If both APIs no data
      if (
        (!result.all_data || result.all_data.length === 0) &&
        (!result2.all_data || result2.all_data.length === 0)
      ) {
        setFormData((prev) => ({
          ...prev,
          Party_name: "",
          Party_Bank: "",
          Party_Branch: "",
          Party_Ac_No: "",
          Ifsc: "",
        }));
      }
    } catch (error) {
      console.error("RTGS fetch error:", error);
    }
  };




  // const handlebankcode = async (code, accoid, name) => {
  //   setbankAccount(code);
  //   setbankaccoid(accoid);
  //   // setbankname(name);
  //   setFormData({
  //     ...formData,
  //     Bank_Code: code,
  //     bc: accoid,
  //   });
  //   try {
  //     const response = await fetch(
  //       `${API_URL}/TransferDataTo-RTGS?Company_Code=${Company_Code}&Bank_Code=${code}`
  //     );

  //     const result = await response.json();

  //     if (response.ok && result.all_data?.length > 0) {
  //       const data = result.all_data[0]; // first record
  //       setUsers(result.all_data);
  //       setFormData(prev => ({
  //         ...prev,
  //         // Party_name: data.Ac_Name_E?.trim() || "",
  //         Our_Bank: data.Bank_Name?.trim() || "",
  //         Our_Branch: data.Branch?.trim() || "",
  //         Our_AC_No: data.Bank_Ac_No?.trim() || "",
  //         // Ifsc: data.IFSC || "",
  //       }));
  //     } else {
  //       // 🔹 If no data found, clear fields
  //       setFormData(prev => ({
  //         ...prev,
  //         Our_Bank: "",
  //         Our_Branch: "",
  //         Our_AC_No: "",
  //       }));
  //     }
  //   } catch (error) {
  //     console.error("RTGS fetch error:", error);
  //   }
  // };



  const handlebankcode = async (code, accoid, name) => {
    setbankAccount(code);
    setbankaccoid(accoid);

    setFormData((prev) => ({
      ...prev,
      Bank_Code: code,
      bc: accoid,
    }));

    try {
      // Existing API
      const response = await fetch(
        `${API_URL}/TransferDataTo-RTGS?Company_Code=${Company_Code}&Bank_Code=${code}`
      );

      const result = await response.json();

      // New API
      const response2 = await fetch(
        `${API_URL}/TransferDataTo-RTGS-FromRecepitPyament?Company_Code=${Company_Code}&Year_Code=${Year_Code}&Bank_Code=${code}`
      );

      const result2 = await response2.json();

      // Existing API Data
      if (response.ok && result.all_data?.length > 0) {
        const data = result.all_data[0];

        setUsers(result.all_data);

        setFormData((prev) => ({
          ...prev,
          Our_Bank: data.Bank_Name?.trim() || "",
          Our_Branch: data.Branch?.trim() || "",
          Our_AC_No: data.Bank_Ac_No?.trim() || "",
        }));
      }

      // New API Data (override if available)
      if (response2.ok && result2.all_data?.length > 0) {
        const data2 = result2.all_data[0];

        setFormData((prev) => ({
          ...prev,
          Our_Bank: data2.Bank_Name?.trim() || prev.Our_Bank,
          Our_Branch: data2.Branch?.trim() || prev.Our_Branch,
          Our_AC_No: data2.Bank_Ac_No?.trim() || prev.Our_AC_No,
        }));
      }

      // If no data from both APIs
      if (
        (!result.all_data || result.all_data.length === 0) &&
        (!result2.all_data || result2.all_data.length === 0)
      ) {
        setFormData((prev) => ({
          ...prev,
          Our_Bank: "",
          Our_Branch: "",
          Our_AC_No: "",
        }));
      }
    } catch (error) {
      console.error("RTGS fetch error:", error);
    }
  };


  const calculateDependentValues = (name, input, formData) => {

    const updatedFormData = { ...formData, [name]: input };

    const totalamt = parseFloat(updatedFormData.SubTotal);
    const saudahamali = parseFloat(updatedFormData.Sauda_Hamali) || 0;
    const commision = parseFloat(updatedFormData.Vatav) || 0;
    const miscAmount = parseFloat(updatedFormData.Other) || 0.0;
    // const Netpayable = Number(updatedFormData.Net_Payable) || 0;

    const Netpayable = (totalamt - saudahamali - commision - miscAmount)


    // const roundedBillAmount = Math.round(billamt);

    // const roundOff = roundedBillAmount - billamt;

    updatedFormData.Net_Payable = Netpayable;
    updatedFormData.Amount = Netpayable;

    console.log({ Netpayable });

    return updatedFormData;
  };

  const handleKeyDownCalculations = async (event) => {
    if (event.key === "Tab") {
      const { name, value } = event.target;

      //Parse value safely
      const newValue =
        name === "" || name === ""
          ? parseFloat(value) || 0
          : parseFloat(value) || value;



      //Update dependent values in head form (unchanged)
      const updatedFormData = await calculateDependentValues(name, value, formData);
      setFormData((prev) => ({
        ...prev,
        ...updatedFormData,
      }));
    }
  };

  const filteredUsers = users.filter((row) =>
    row.Doc_No?.toString().includes(searchTerm) ||
    row.ShetkariName?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const round2 = (num) => Math.round(num * 100) / 100;

  const getCalculationData = () => {
    const selectedRows = users
      .filter(row => selectedPattiIds.includes(row.Id))
      .map(row => ({
        ...row,
        amount: round2(Number(row.Patti_Amount || 0))
      }));

    const negatives = selectedRows.filter(r => r.amount < 0);
    const positives = selectedRows.filter(r => r.amount > 0);

    let runningBalance = round2(
      negatives.reduce((sum, r) => sum + Math.abs(r.amount), 0)
    );

    const calculationMap = {};

    for (let pos of positives) {

      if (runningBalance <= 0) {
        calculationMap[pos.Id] = pos.Patti_Amount || 0;
        continue;
      }

      // CASE 1: Positive smaller than balance
      if (pos.amount <= runningBalance) {

        const newBalance = round2(runningBalance - pos.amount);

        calculationMap[pos.Id] =
          `${runningBalance.toLocaleString("en-IN")} - ${pos.amount.toLocaleString("en-IN")} = ${newBalance.toLocaleString("en-IN")}`;

        runningBalance = newBalance;

      }
      // CASE 2: Positive greater than balance
      else {

        const remainingPositive = round2(pos.amount - runningBalance);

        calculationMap[pos.Id] =
          `${pos.amount.toLocaleString("en-IN")} - ${runningBalance.toLocaleString("en-IN")} = ${remainingPositive.toLocaleString("en-IN")}`;

        runningBalance = 0;
      }
    }

    return calculationMap;
  };


  const calculationData = getCalculationData();
  const handleSearch = () => {
    // Nothing special needed if we filter live
    console.log("Searching:", searchTerm);
  };

  const totalPattiAmount = filteredUsers.reduce((total, row) => {
    return total + parseFloat(row.Patti_Amount || 0);
  }, 0);

  const selectedNegativeRows = users
    .filter(row =>
      selectedPattiIds.includes(row.Id) &&
      Number(row.Patti_Amount || 0) < 0
    );

  const totalSelectedNegative = selectedNegativeRows.reduce(
    (sum, row) => sum + Number(row.Patti_Amount || 0),
    0
  );

  return (
    <>
      <UserAuditInfo
        createdBy={formData.Created_By}
        modifiedBy={formData.Modified_By}
        title={"RTGS"}
      />
      <div style={{ marginTop: "30px" }}>
        <ToastContainer autoClose={500} />
        <ActionButtonGroup
          handleAddOne={handleAddOne}
          addOneButtonEnabled={addOneButtonEnabled}
          handleSaveOrUpdate={handleSaveOrUpdate}
          saveButtonEnabled={saveButtonEnabled}
          isEditMode={isEditMode}
          handleEdit={handleEdit}
          editButtonEnabled={editButtonEnabled}
          handleDelete={handleDelete}
          deleteButtonEnabled={deleteButtonEnabled}
          handleCancel={handleCancel}
          cancelButtonEnabled={cancelButtonEnabled}
          handleBack={handleBack}
          backButtonEnabled={backButtonEnabled}
          permissions={permissions}
          component={
            <div style={{ display: "flex" }}>
              <RTGSReport Slip_No={formData.Slip_No} disabledFeild={!addOneButtonEnabled} />
              <CheckRTGSReport Slip_No={formData.Slip_No} disabledFeild={!addOneButtonEnabled} />
              <PattiRTGSReport Slip_No={formData.Slip_No} disabledFeild={!addOneButtonEnabled} />
            </div>
          }
        />
        <div>
          <NavigationButtons
            handleFirstButtonClick={handleFirstButtonClick}
            handlePreviousButtonClick={handlePreviousButtonClick}
            handleNextButtonClick={handleNextButtonClick}
            handleLastButtonClick={handleLastButtonClick}
            highlightedButton={highlightedButton}
            isEditing={isEditing}
            isFirstRecord={formData.Company_Code === 1}
          />
        </div>
      </div>

      <div>
        <form>
          <div className="bg-white rounded-lg shadow-md p-2 max-w-8xl mx-auto mb-10">
            <div className="flex flex-col space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-6 gap-3">
                <div className="col-span-1">
                  <label
                    htmlFor="changeNo"
                    className="block text-left text-sm font-bold text-gray-800  flex items-center"
                  >
                    Change No
                  </label>
                  <input
                    type="text"
                    id="changeNo"
                    name="changeNo"
                    autoComplete="off"
                    onKeyDown={handleKeyDown}
                    disabled={!addOneButtonEnabled}
                    className="w-full px-2 py-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  />
                </div>


                <div className="col-span-1">
                  <label
                    htmlFor="group_Code"
                    className="block text-left text-sm font-bold text-gray-800 flex items-center"
                  >
                    Slip No
                    <span className="ml-1 text-xs text-gray-500">
                      (Auto-generated)
                    </span>
                  </label>
                  <div className="relative group">
                    <input
                      type="text"
                      id="Slip_No"
                      name="Slip_No"
                      value={formData.Slip_No}
                      onChange={handleChange}
                      disabled
                      className="w-full px-2 py-1 bg-gray-100 border border-gray-300 rounded-md shadow-sm sm:text-sm"
                    />
                    <div className="absolute right-3 top-2.5 text-gray-400">
                      <svg
                        className="h-5 w-5"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        aria-hidden="true"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <div className="absolute left-0 -top-6 hidden group-hover:block bg-gray-800 text-white text-xs px-2 py-1 rounded whitespace-nowrap">
                      Auto-generated and read-only
                    </div>
                  </div>
                </div>

                <div className="col-span-1 flex flex-col">
                  <label
                    htmlFor="Doc_Date"
                    className="text-left text-sm font-bold text-gray-800"
                  >
                    Date
                  </label>

                  <input
                    type="date"
                    id="Doc_Date"
                    name="Doc_Date"
                    value={formData.Doc_Date}
                    onChange={handleChange}
                    ref={inputRef}
                    disabled={!isEditing && addOneButtonEnabled}
                    className={`mt-1 w-[150px] px-2 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${!isEditing && addOneButtonEnabled
                      ? "bg-gray-100 cursor-not-allowed"
                      : ""
                      }`}
                  />
                </div>

                <div className="col-span-1 justify-self-start">
                  <label
                    htmlFor="PaymentCategory"
                    className="block text-left text-sm font-bold text-gray-800"
                  >
                    Payment Category
                  </label>

                  <select
                    id="PaymentCategory"
                    name="PaymentCategory"
                    value={formData.PaymentCategory || "O"}
                    onChange={handleChange}
                    disabled={isEditMode ? isEditing : addOneButtonEnabled}
                    className="w-[160px] px-2 py-1 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                  >
                    <option value="O">Other</option>
                    <option value="P">Against Patti Payment</option>
                  </select>
                </div>

              </div>
              <div className="grid grid-cols-1 md:grid-cols-12 gap-3 mt-1">
                <div className="col-span-3">
                  <label
                    htmlFor="Item_Select"
                    className="block text-left text-sm font-bold text-gray-800 text-base"
                  >
                    Bank Code:
                  </label>
                  <div className="flex-grow">
                    <AccountMasterHelp
                      onAcCodeClick={handlebankcode}
                      CategoryName={BankName}
                      CategoryCode={BankCode ?? formData.Bank_Code}
                      name="Bank_Code"
                      Ac_type={[]}
                      disabledFeild={!isEditing && addOneButtonEnabled}
                    />
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-12 gap-3 mt-1">
                <div className="col-span-3">
                  <label
                    htmlFor="Our_Bank"
                    className="block text-left text-sm font-bold text-gray-800  flex items-center"
                  >
                    Our Bank
                  </label>
                  <input
                    type="text"
                    id="Our_Bank"
                    name="Our_Bank"
                    value={formData.Our_Bank}
                    onChange={handleChange}
                    ref={inputRef}
                    disabled={!isEditing && addOneButtonEnabled}
                    className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${!isEditing && addOneButtonEnabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  />
                </div>

                <div className="col-span-3">
                  <label
                    htmlFor="Our_Branch"
                    className="block text-left text-sm font-bold text-gray-800  flex items-center"
                  >
                    Our Branch
                  </label>
                  <input
                    type="text"
                    id="Our_Branch"
                    name="Our_Branch"
                    value={formData.Our_Branch}
                    onChange={handleChange}
                    ref={inputRef}
                    disabled={!isEditing && addOneButtonEnabled}
                    className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${!isEditing && addOneButtonEnabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  />
                </div>

                <div className="col-span-3">
                  <label
                    htmlFor="Our_AC_No"
                    className="block text-left text-sm font-bold text-gray-800  flex items-center"
                  >
                    Our A/C No
                  </label>
                  <input
                    type="text"
                    id="Our_AC_No"
                    name="Our_AC_No"
                    value={formData.Our_AC_No}
                    onChange={handleChange}
                    ref={inputRef}
                    disabled={!isEditing && addOneButtonEnabled}
                    className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${!isEditing && addOneButtonEnabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  />
                </div>
                <div className="col-span-3">
                  <label
                    htmlFor="Bank_Name"
                    className="block text-left text-sm font-bold text-gray-800  flex items-center"
                  >
                    Bank Name
                  </label>
                  <input
                    type="text"
                    id="Bank_Name"
                    name="Bank_Name"
                    value={formData.Bank_Name}
                    onChange={handleChange}
                    ref={inputRef}
                    disabled={!isEditing && addOneButtonEnabled}
                    className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${!isEditing && addOneButtonEnabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  />
                </div>
              </div>


              <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mt-1">


                <div className="col-span-3">
                  <label
                    htmlFor="Item_Select"
                    className="block text-left text-sm font-bold text-gray-800 text-base"
                  >
                    RTGS To Party:
                  </label>
                  <div className="flex-grow">
                    <AccountMasterHelp
                      onAcCodeClick={handlePurchaseAccount}
                      CategoryName={PurchName}
                      CategoryCode={PurchCode ?? formData.Ac_code}
                      name="Ac_code"
                      Ac_type={[]}
                      disabledFeild={!isEditing && addOneButtonEnabled}
                    />
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mt-1">
                <div className="col-span-3">
                  <label
                    htmlFor="Party_name"
                    className="block text-left text-sm font-bold text-gray-800  flex items-center"
                  >
                    Party Name
                  </label>
                  <input
                    type="text"
                    id="Party_name"
                    name="Party_name"
                    value={formData.Party_name}
                    onChange={handleChange}
                    ref={inputRef}
                    disabled={!isEditing && addOneButtonEnabled}
                    className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${!isEditing && addOneButtonEnabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  />
                </div>

                <div className="col-span-3">
                  <label
                    htmlFor="Party_Bank"
                    className="block text-left text-sm font-bold text-gray-800  flex items-center"
                  >
                    Party Bank
                  </label>
                  <input
                    type="text"
                    id="Party_Bank"
                    name="Party_Bank"
                    value={formData.Party_Bank}
                    onChange={handleChange}
                    ref={inputRef}
                    disabled={!isEditing && addOneButtonEnabled}
                    className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${!isEditing && addOneButtonEnabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  />
                </div>

                <div className="col-span-3">
                  <label
                    htmlFor="Party_Branch"
                    className="block text-left text-sm font-bold text-gray-800  flex items-center"
                  >
                    Party Branch
                  </label>
                  <input
                    type="text"
                    id="Party_Branch"
                    name="Party_Branch"
                    value={formData.Party_Branch}
                    onChange={handleChange}
                    ref={inputRef}
                    disabled={!isEditing && addOneButtonEnabled}
                    className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${!isEditing && addOneButtonEnabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  />
                </div>

                <div className="col-span-3">
                  <label
                    htmlFor="Party_Ac_No"
                    className="block text-left text-sm font-bold text-gray-800  flex items-center"
                  >
                    Party A/C No
                  </label>
                  <input
                    type="text"
                    id="Party_Ac_No"
                    name="Party_Ac_No"
                    value={formData.Party_Ac_No}
                    onChange={handleChange}
                    ref={inputRef}
                    disabled={!isEditing && addOneButtonEnabled}
                    className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${!isEditing && addOneButtonEnabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  />
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-12 gap-4 mt-1">
                <div className="col-span-3">
                  <label
                    htmlFor="Ifsc"
                    className="block text-left text-sm font-bold text-gray-800  flex items-center"
                  >
                    IFSC
                  </label>
                  <input
                    type="text"
                    id="Ifsc"
                    name="Ifsc"
                    value={formData.Ifsc}
                    onChange={handleChange}
                    ref={inputRef}
                    disabled={!isEditing && addOneButtonEnabled}
                    className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${!isEditing && addOneButtonEnabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  />
                </div>
                <div className="col-span-3">
                  <label
                    htmlFor="UTR_No"
                    className="block text-left text-sm font-bold text-gray-800  flex items-center"
                  >
                    UTR No
                  </label>
                  <input
                    type="text"
                    id="UTR_No"
                    name="UTR_No"
                    value={formData.UTR_No}
                    onChange={handleChange}
                    disabled={!isEditing && addOneButtonEnabled}
                    className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${!isEditing && addOneButtonEnabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  />
                </div>

                <div className="col-span-2">
                  <label
                    htmlFor="Amount"
                    className="block text-left text-sm font-bold text-gray-800  flex items-center"
                  >
                    Amount
                  </label>
                  <input
                    type="number"
                    id="Amount"
                    name="Amount"
                    value={
                      formData.Amount !== null ? formData.Amount : ""
                    }
                    onChange={handleChange}
                    disabled
                    className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${!isEditing && addOneButtonEnabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  />
                </div>

                <div className="col-span-2">
                  <label
                    htmlFor="Charges"
                    className="block text-left text-sm font-bold text-gray-800  flex items-center"
                  >
                    Charges
                  </label>
                  <input
                    type="number"
                    id="Charges"
                    name="Charges"
                    value={
                      formData.Charges !== null ? formData.Charges : ""
                    }
                    onChange={handleChange}
                    disabled={!isEditing && addOneButtonEnabled}
                    className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${!isEditing && addOneButtonEnabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  />
                </div>

                <div className="col-span-2">
                  <label
                    htmlFor="cheque_No"
                    className="block text-left text-sm font-bold text-gray-800  flex items-center"
                  >
                    Cheque No
                  </label>
                  <input
                    type="text"
                    id="cheque_No"
                    name="cheque_No"
                    value={formData.cheque_No !== null ? formData.cheque_No : ""}
                    onChange={handleChange}
                    disabled={!isEditing && addOneButtonEnabled}
                    className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${!isEditing && addOneButtonEnabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  />
                </div>
              </div>



              <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-1">
                <div className="col-span-1">
                  <label
                    htmlFor="Challan_No"
                    className="block text-left text-sm font-bold text-gray-800  flex items-center"
                  >
                    Challan No
                  </label>
                  <input
                    type="number"
                    id="Challan_No"
                    name="Challan_No"
                    value={formData.Challan_No !== null ? formData.Challan_No : ""}
                    onChange={handleChange}
                    disabled={!isEditing && addOneButtonEnabled}
                    className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${!isEditing && addOneButtonEnabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  />
                </div>
                <div className="col-span-1">
                  <label
                    htmlFor="Total"
                    className="block text-left text-sm font-bold text-gray-800  flex items-center"
                  >
                    Total
                  </label>
                  <input
                    type="number"
                    id="Total"
                    name="Total"
                    value={formData.Total !== null ? formData.Total : ""}
                    onChange={handleChange}
                    disabled={!isEditing && addOneButtonEnabled}
                    className={`w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-500 ${!isEditing && addOneButtonEnabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
                  />
                </div>
              </div>


            </div>
          </div>
        </form>
        {/* ================= TABLE SECTION ================= */}
        <div >
          <div style={{ width: "70%", marginBottom: "10px" }}>
            <SearchBar
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onSearch={handleSearch}
            />
          </div>
          {selectedNegativeRows.length > 0 && (
            <div style={{
              width: "70%",
              marginBottom: "15px",
              padding: "10px",
              background: "#fff3f3",
              border: "1px solid #ffcccc",
              borderRadius: "6px"
            }}>
              <strong>Selected Negative Pattis:</strong>

              {selectedNegativeRows.map(row => (
                <div key={row.Doc_No}>
                  Patti {row.Doc_No} : {row.Patti_Amount}
                </div>
              ))}

              <div style={{ marginTop: "5px", fontWeight: "bold" }}>
                Total Negative: {totalSelectedNegative}
              </div>
            </div>
          )}
          <TableContainer
            component={Paper}
            className="mt-1"
            sx={{ width: "70%", marginBottom: "50px" }}
          >
            <Table aria-label="user table">
              <TableHead>
                <TableRow>
                  <TableCell sx={headerCellStyle}>Check</TableCell>
                  <TableCell sx={headerCellStyle}>Patti No</TableCell>
                  <TableCell sx={headerCellStyle}>Shetkari Code</TableCell>
                  <TableCell sx={headerCellStyle}>Shetkari Name</TableCell>
                  <TableCell sx={headerCellStyle}>Patti Amount</TableCell>
                  <TableCell sx={headerCellStyle}>Calculation</TableCell>
                </TableRow>
              </TableHead>


              <TableBody>
                {filteredUsers.map((row, index) => (
                  <TableRow key={row.Id}>


                    {/* Checkbox */}

                    <TableCell sx={{ padding: "0px 1px", textAlign: "center" }}>
                      <Checkbox
                        checked={selectedPattiIds.includes(row.Id)}
                        disabled={isEditMode ? isEditing : addOneButtonEnabled}
                        onChange={(e) => handleChangeCheckbox(e, row.Id)}
                      />
                    </TableCell>


                    {/* Patti No */}
                    <TableCell sx={{ padding: "0px 1px", textAlign: "center" }}>
                      {row.Doc_No}
                    </TableCell>

                    <TableCell sx={{ padding: "0px 1px", textAlign: "center" }}>
                      {row.ShetkariAcCode || "-"}
                    </TableCell>


                    <TableCell sx={{ padding: "0px 1px", textAlign: "center" }}>
                      {row.ShetkariName || "-"}
                    </TableCell>

                    <TableCell sx={{ padding: "0px 1px", textAlign: "center" }}>
                      {row.Patti_Amount || "-"}
                    </TableCell>

                    <TableCell sx={{ padding: "0px 1px", textAlign: "center" }}>
                      {selectedPattiIds.includes(row.Id)
                        ? calculationData[row.Id] || 0
                        : ""}
                    </TableCell>

                  </TableRow>
                ))}
                <TableRow>
                  <TableCell
                    colSpan={4}
                    sx={{
                      fontWeight: "bold",
                      textAlign: "right",
                      backgroundColor: "#f5f5f5",
                      padding: "2px 1px",
                    }}
                  >
                    Total:
                  </TableCell>

                  <TableCell
                    sx={{
                      fontWeight: "bold",
                      textAlign: "center",
                      backgroundColor: "#f5f5f5",
                      padding: "2px 1px",
                    }}
                  >
                    {totalPattiAmount.toFixed(2)}
                  </TableCell>
                </TableRow>
              </TableBody>

            </Table>
          </TableContainer>
        </div>

        <div style={{ display: 'grid' }} >
          <div className="SaleBill-row" >
            <Grid container spacing={1} mt={5} mb={15} sx={{ textAlign: 'left' }}>
              <Grid container spacing={1} justifyContent="flex-end" alignItems="center" >
                <Grid item xs={1}>
                  <label className="SugarSaleBillLabel">SubTotal :</label>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    variant="outlined"
                    name="SubTotal"
                    autoComplete="off"
                    value={formatReadableAmount(formData.SubTotal) || 0.0}
                    disabled
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    error={!!formErrors.SubTotal}
                    helperText={formErrors.SubTotal}
                    size="small"
                    inputProps={{
                      sx: { textAlign: 'right' },
                      inputMode: 'decimal',
                      pattern: '[0-9]*[.,]?[0-9]+',
                      onInput: validateNumericInput,
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        backgroundColor: 'white',
                        opacity: 1,
                        '& .Mui-disabled': {
                          color: 'black',
                          WebkitTextFillColor: 'black',
                          opacity: 1,
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>



              <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }}>
                <Grid item xs={1}>
                  <label className="SugarSaleBillLabel">Sauda Hamali:</label>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    name="Sauda_Hamali"
                    autoComplete="off"
                    value={formData.Sauda_Hamali || 0.0}
                    onKeyDown={handleKeyDownCalculations}
                    onChange={handleChange}
                    disabled={!isEditing && addOneButtonEnabled}
                    error={Boolean(formErrors.Sauda_Hamali) || 0.00}
                    helperText={formErrors.Sauda_Hamali || ''}
                    size="small"
                    inputProps={{
                      sx: { textAlign: 'right' },
                      inputMode: 'decimal',
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        backgroundColor: 'white',
                        opacity: 1,
                        '& .Mui-disabled': {
                          color: 'black',
                          WebkitTextFillColor: 'black',
                          opacity: 1,
                        },
                      },
                    }}

                  />
                </Grid>
              </Grid>





              <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }} >

                <Grid item xs={1}>
                  <label className="SugarSaleBillLabel">VATAV/Commission :</label>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    variant="outlined"
                    name="Vatav"
                    autoComplete="off"
                    value={formData.Vatav || 0.0}
                    onChange={handleChange}
                    onKeyDown={handleKeyDownCalculations}
                    disabled={!isEditing && addOneButtonEnabled}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    error={!!formErrors.Vatav}
                    helperText={formErrors.Vatav}
                    size="small"
                    inputProps={{
                      sx: { textAlign: 'right' },
                      inputMode: 'decimal',
                      pattern: '[0-9]*[.,]?[0-9]+',
                      onInput: validateNumericInput,
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        backgroundColor: 'white',
                        opacity: 1,
                        '& .Mui-disabled': {
                          color: 'black',
                          WebkitTextFillColor: 'black',
                          opacity: 1,
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }}>
                <Grid item xs={1}>
                  <label className="SugarSaleBillLabel">Other +/- :</label>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    name="Other"
                    autoComplete="off"
                    value={formData.Other || 0.0}
                    onKeyDown={handleKeyDownCalculations}
                    onChange={handleChange}
                    disabled={!isEditing && addOneButtonEnabled}
                    error={Boolean(formErrors.Other)}
                    helperText={formErrors.Other || ''}
                    size="small"
                    inputProps={{
                      sx: { textAlign: 'right' },
                      inputMode: 'decimal',
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        backgroundColor: 'white',
                        opacity: 1,
                        '& .Mui-disabled': {
                          color: 'black',
                          WebkitTextFillColor: 'black',
                          opacity: 1,
                        },
                      },
                    }}

                  />
                </Grid>
              </Grid>

              <Grid container spacing={1} justifyContent="flex-end" alignItems="center" style={{ marginTop: '-6px' }}>
                <Grid item xs={1}>
                  <label className="SugarSaleBillLabel">Net Payable:</label>
                </Grid>
                <Grid item xs={12} sm={2}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    name="Net_Payable"
                    autoComplete="off"
                    value={formData.Net_Payable || 0.0}
                    onKeyDown={handleKeyDownCalculations}
                    onChange={handleChange}
                    disabled
                    error={Boolean(formErrors.Net_Payable)}
                    helperText={formErrors.Net_Payable || ''}
                    size="small"
                    inputProps={{
                      sx: { textAlign: 'right' },
                      inputMode: 'decimal',
                      pattern: '[0-9]*[.,]?[0-9]+',
                      onInput: validateNumericInput,
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        fontSize: '16px',
                        fontWeight: 'bold',
                        color: 'black',
                        backgroundColor: 'white',
                        opacity: 1,
                        '& .Mui-disabled': {
                          color: 'black',
                          WebkitTextFillColor: 'black',
                          opacity: 1,
                        },
                      },
                    }}
                  />
                </Grid>
              </Grid>

            </Grid>
          </div>
        </div>

      </div>

    </>
  );
};
export default RTGSForm;
